// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import { createRoot, Root } from 'react-dom/client';
interface ModalPopUpProps extends React.PropsWithChildren<{}> {
    isOpen: boolean;
    class?: string[];
}

class ModalPopUp extends React.Component<ModalPopUpProps, any> {

    portal: HTMLElement;
    portalContainer: HTMLElement;
    private _root: Root | null = null;

    constructor(props: ModalPopUpProps) {
        super(props);

    }

    componentDidMount() {
        this.portalContainer = document.getElementById('inovx-modal-pop-up');
        if (!this.portalContainer) {
            this.portalContainer = document.createElement('div');
            this.portalContainer.id = 'inovx-modal-pop-up';
            document.body.appendChild(this.portalContainer);
        }

        this.renderModalContent(this.props);
    }

    private renderModalContent = (props: ModalPopUpProps) => {
        if (props.isOpen) {
            if (!this.portal) {
                var additionalClasses = '';
                if (this.props.class && this.props.class.length > 0) {
                    additionalClasses = this.props.class.join(' ');
                }

                this.portal = document.createElement('div');
                this.portal.className = `cd-panel-modal is-visible ${additionalClasses}`;

                this.portalContainer.appendChild(this.portal);
            }

            const content = <div className='cd-panel-modal-middle'><div className='cd-panel-modal-inner'>{props.children}</div></div>;
            if (!this._root) {
                this._root = createRoot(this.portal);
            }
            this._root.render(content);
        } else if (this.portal) {
            $(this.portal).removeClass('is-visible');
            this._root?.unmount();
            this._root = null;
            $(this.portal).remove();
            this.portal = null;
        }
    }

    componentWillUnmount() {
        if (this.portal) {
            this._root?.unmount();
            this._root = null;
            $(this.portal).remove();
            this.portal = null;
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: ModalPopUpProps) {
        this.renderModalContent(nextProps);
    }

    render():any {
        return null;
    }

}

export default ModalPopUp;